module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/signature2021-c1093b04f956731cb564b3f7776d87cf.png";